import Location from './location'

export default Location
